import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class SimpleMap extends Component {
  static defaultProps = {
    center: {
      lat: 32.245801,
      lng: -8.532439
    },
    zoom: 11
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '40vh', width: '100%', padding: '2% 2% 2% 0%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyCXfdv0sWsfff5G-Kyr0TGnrLlSOX_ecls'}}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <AnyReactComponent
            lat={32.245801}
            lng={-8.532439}
            text="My City"
          />
        </GoogleMapReact>
      </div>
    );
  }
}

export default SimpleMap;
